import React from 'react';

import Routes from 'routes';

const App: React.FC = () => <Routes />;

export default App;
